import React from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { browserHistory } from 'react-router';

import { selectLoading } from '@lib/selectors';
import { NOTIFICATION_TYPE_CHAT } from 'components/WebNotification/constants';

import { closeWebNotification, ignoreWebNotification } from '../actions';
import {
  makeSelectWebNotificationType,
  makeSelectWebNotificationTitle,
  makeSelectWebNotificationData,
  makeSelectWebNotificationIgnore,
} from '../selectors';

const WebNotification = React.lazy(() => import('components/WebNotification'));

export default function AppWebNotifications({ location }: any) {
  const isLoading = useSelector(selectLoading);
  const webNotificationIgnore = useSelector(makeSelectWebNotificationIgnore());
  const webNotificationTitle = useSelector(makeSelectWebNotificationTitle());
  const webNotificationType = useSelector(makeSelectWebNotificationType());
  const webNotificationData = useSelector(makeSelectWebNotificationData());
  const dispatch = useDispatch();

  const dispatchWebNotificationClose = () => {
    dispatch(closeWebNotification());
  };
  const dispatchWebNotificationIgnore = () => {
    dispatch(ignoreWebNotification());
  };

  const handleWebNotificationClick = () => {
    if (webNotificationData.notificationType === NOTIFICATION_TYPE_CHAT) {
      const patientId =
        webNotificationData.patient && typeof webNotificationData.patient === 'object'
          ? webNotificationData.patient._id
          : webNotificationData.patient;

      browserHistory.push(`/patients/${patientId}/chat`);

      dispatchWebNotificationClose();
    }
  };

  const handleWebNotificationShow = () => {
    dispatchWebNotificationIgnore();
  };

  const showWebNotification = !isLoading && webNotificationTitle !== '';
  const patientId =
    (webNotificationData && typeof webNotificationData.patient && typeof webNotificationData.patient === 'object'
      ? webNotificationData.patient._id
      : webNotificationData.patient) || '';
  const regExp = new RegExp(`/patients/${patientId}/chat`);
  const disableActiveWindow = webNotificationType === NOTIFICATION_TYPE_CHAT && regExp.test(location?.pathname);
  if (!showWebNotification) {
    return null;
  }
  return (
    <React.Suspense fallback={null}>
      <WebNotification
        title={webNotificationTitle}
        type={webNotificationType}
        ignore={webNotificationIgnore}
        disableActiveWindow={disableActiveWindow}
        onClose={dispatchWebNotificationClose}
        onClick={handleWebNotificationClick}
        onShow={handleWebNotificationShow}
      />
    </React.Suspense>
  );
}
